import { useEffect, useState } from "react";
import ListBox from "../common/ListBox";
import { useDispatch, useSelector } from "react-redux";
import UMCContentSplitLayout from "../common/UMCContentSplitLayout";
// import { getComponentFromType } from "../../utils/CommonUtils";
import { formatToLabelValue } from "../../utils/SchemaParseUtils";
import CreateUserProfDetailView from "./CreateUserProfDetailView";
import { getSchemaDomains } from "../../store/actions/CommonActions";
import { UUM_URL } from "../../utils/Config";
import { setProfileSummarySchema, setCreateUserFromDirectorySynchro, setCurrentUserSCIMIndex } from "../../store/reducers/UUMReducer";
import { setContentLoading } from "../../store/reducers/CommonReducer";
import CreateUserDetailView from "./CreateUserDetailView";
import UMCAttributeView from "../common/UMCAttributeView";
import { CREATE } from "../../utils/Constants";
import { getTranslated } from "../../utils/CommonUtils";


const UserProfileSummaryView = (props) => {

    const [selectedProfile, setSelectedProfile] = useState("personalized")
    const [customProfile, setCustomProfile] = useState("")
    const [isSummaryView, setIsSummaryView] = useState(true)
    const [domain_1View, setDomain_1View] = useState()
    const [domain_2View, setDomain_2View] = useState()

    const profileSummarySchema = useSelector(state => state.uum.profileSummarySchema)
    const dict = useSelector(state => state.common.dict)

    const dispatch = useDispatch()

    useEffect(() => {
        // if (!profileSummarySchema?.length) {
        dispatch(setContentLoading(true))
        const request = { url: `${UUM_URL}/easyuserprofile/schema/create?modelType=${props.type === "profile" ? "easyuserprofile" : "easyuser"}`, action: setProfileSummarySchema }
        dispatch(getSchemaDomains(request))
        // }
    }, [props.type])

    useEffect(() => {
        if (profileSummarySchema?.length) {
            const domain1View = getDomain1Content(profileSummarySchema[0])
            setDomain_1View(domain1View)

            const domain2View = getDomain2Content(profileSummarySchema[1])
            setDomain_2View(domain2View)
            
            // dispatch(setContentLoading(false))
        }
    }, [profileSummarySchema, selectedProfile, dict])

    useEffect(() => {
        (domain_1View && domain_2View) && dispatch(setContentLoading(false))
    }, [domain_1View, domain_2View])

    
    const handleDefaultProfSelect = (value) => {
        setSelectedProfile(value)
        setCustomProfile("")
    }

    const handleCustomProfSelect = (value) => {
        setCustomProfile(value)
    }

    const getDomain1Content = (domain) => {

        const view = domain.subdomain.map(subdomain => {
            return <div className="prof-bottom-divider">
                {subdomain?.attributes?.map(attribute => {
                    let attr = formatToLabelValue(attribute)
                    attr.value = selectedProfile
                    attr.handleChange = (value) => handleDefaultProfSelect(value)

                    return <div className="default-prof-item">
                        <UMCAttributeView attribute={attr} />
                    </div>
                })}
            </div>
        })

        return <div className="default-prof-list">{view}</div>
    }

    const getDomain2Content = (domain) => {

        return <ListBox
            listItems={domain?.attribute[0]?.enum}
            value={selectedProfile}
            disabled={selectedProfile !== "personalized"}
            width="calc(100%)"
            placeholder={getTranslated(dict, "PH_SEARCH_PROFILES")}
            className="user-prof-dd listbox-cmnt"
            handleListBoxSelect={(value) => handleCustomProfSelect(value)}
        />
    }

    const changeCreateMode = (value = false) => {
        setIsSummaryView(value)
        !value && dispatch(setContentLoading(true))
    }

    const goBackHandlerFunction = () => {
        props.setListViewMode && props.setListViewMode(true)
        if (props.isFromDirectorySynchro) {
            dispatch(setCreateUserFromDirectorySynchro(false))
            dispatch(setCurrentUserSCIMIndex(0))
            props.selectedRows([])
        }
    }

    return isSummaryView ? <UMCContentSplitLayout
        domain_1={domain_1View}
        domain_2={domain_2View}
        heading_1={props.heading_1}
        heading_2={props.heading_2}
        okBtnLabel={getTranslated(dict, "LABEL_NEXT")}
        goBackHandler={goBackHandlerFunction
        }
        handleOK={changeCreateMode}
        disablOKBtn={(selectedProfile === "personalized" && !customProfile)}
    /> :
        props.type === "profile" ? <CreateUserProfDetailView
            selectedProfile={selectedProfile === "personalized" ? customProfile : selectedProfile}
            changeCreateMode={changeCreateMode}
            backToListView={props.setListViewMode}
            mode={CREATE}
        /> :
            <CreateUserDetailView
                selectedProfile={selectedProfile === "personalized" ? customProfile : selectedProfile}
                changeCreateMode={changeCreateMode}
                backToListView={props.setListViewMode}
                mode={CREATE}
                isFromDirectorySynchro= {props.isFromDirectorySynchro}
                selectedRows={props.selectedRows}
            />
}

export default UserProfileSummaryView